import { useTranslation } from 'react-i18next'

import { parseServerValidation } from '../../../../../../utils/validation'
import { FormModal } from '../../../../../Form'
import {
  APPLICANT_DECISION_ACTION_LABEL_KEY,
  APPLICANT_DECISION_CONFIRM_TITLE_KEY,
  QA_NAME_APPLICANT_DECISION_MODAL,
} from '../ApplicantDecisionPanel.constants'
import {
  getApplicantDecisionConfirmText,
  getApplicantDecisionModalNotifications,
} from '../ApplicantDecisionPanel.utils'

import { APPLICANT_DECISION_MODAL_INITIAL_VALUES } from './ApplicantDecisionModal.constants'
import {
  getApplicantDecisionModalNote,
  getApplicantDecisionModalValidationSchema,
} from './ApplicantDecisionModal.utils'
import { ApplicantDecisionModalFields } from './ApplicantDecisionModalFields'

function ApplicantDecisionModal({ action, applicantData, onClose, onSubmit }) {
  const { t } = useTranslation()

  async function handleSubmit({ setErrors, setSubmitting, values }) {
    return onSubmit(getApplicantDecisionModalNote(values)).catch(() => {
      setSubmitting(false)

      setErrors(
        parseServerValidation(t('RentalPortal.ApplicantDecisionSaveErrorKey'))
      )
    })
  }

  return (
    <FormModal
      Fields={ApplicantDecisionModalFields}
      containerProps={{ qaName: QA_NAME_APPLICANT_DECISION_MODAL }}
      formBodyProps={{
        submitButtonText: APPLICANT_DECISION_ACTION_LABEL_KEY[action],
        withNotifications: true,
      }}
      formFieldsProps={{
        action,
        description: getApplicantDecisionConfirmText({
          action,
          applicantData,
          t,
        }),
      }}
      formTitle={APPLICANT_DECISION_CONFIRM_TITLE_KEY[action]}
      initialNotifications={getApplicantDecisionModalNotifications({
        action,
        t,
      })}
      initialValues={APPLICANT_DECISION_MODAL_INITIAL_VALUES}
      validationSchema={getApplicantDecisionModalValidationSchema({
        action,
        t,
      })}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default ApplicantDecisionModal
